module.exports = __webpack_public_path__ + "img/box1_bg_dark.a21c5896.png";